// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1FR0o","right":"Footer_right__1Fike","buttons":"Footer_buttons__14Btw"};